import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { UserDTO } from 'src/app/models/UserDTO.model';
import { CustomerService } from 'src/app/services/customer.service';
import { LoginService } from 'src/app/services/login.service';
import { PermissionService } from 'src/app/services/permission.service';
import { Alert } from 'src/app/shared/models/Alert';
import { AlertService } from 'src/app/shared/services/alert.service';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
@Component({
    selector: 'app-create-password',
    templateUrl: './create-password.component.html',
    styleUrls: ['./create-password.component.css'],
    imports: [CommonModule, FormsModule, RouterModule]
})
export class CreatePasswordComponent {
  usrPassword: string = '';
  confirmPassword: string = '';
  errorMessage: string = '';
  loginError: string = '';
  fieldsCompleted: boolean = false;
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
  hoverClassAdded: boolean = false;
  hoverClassAdded2: boolean = false;
  isLengthValid: boolean = false;
  hasNumber: boolean = false;
  hasCapitalCase: boolean = false;
  hasSmallCase: boolean = false;
  hasSpecialChar: boolean = false;
  passwordsMatch: boolean = false;
  user: UserDTO = {} as UserDTO;
  alert: Alert = {} as Alert;

  constructor(private alertService: AlertService, private customerService: CustomerService, private router: Router, private loginService: LoginService, private permissionService: PermissionService) {  }

  onSubmit(): void {
    this.user.userPassword = this.usrPassword;
    this.user.userMail = localStorage.getItem('UserEmail') ?? '';

    this.customerService.updatePassword(this.user).subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleSaveSuccess(Data)
          : this.handleSaveError(StatusCode),
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        this.alertService.updateAlertState(
          this.alert
        );

        this.clearFields();
      }
    );
  }

  handleSaveSuccess(Data: boolean) {

    if(Data) {
      this.alert = {
        alertMessage: 'Password updated successfully',
        alertType: 'alert alert-success',
        alertCenter: false,
        alerTitle: '',
        duration: 3000
      };
      localStorage.setItem('AlertObject', JSON.stringify(this.alert));
      this.alertService.updateAlertState(
        this.alert
      );
      localStorage.clear();
      this.router.navigate(['/login']);
    }
    else {
      this.alert = {
        alertMessage: 'Unexpected error. Please try again later.',
        alertType: 'alert alert-danger',
        alertCenter: false,
        alerTitle: '',
        duration: 3000
      };
      this.alertService.updateAlertState(
        this.alert
      );
    }
  }

  handleSaveError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-warning',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
    this.clearFields();
  }

  clearFields() {
    this.usrPassword = '';
    this.confirmPassword = '';
    this.fieldsCompleted = false;
  }

  checkFields() {
    this.passwordsMatch = this.usrPassword === this.confirmPassword;
  
    this.fieldsCompleted = this.isLengthValid &&
                           this.hasNumber &&
                           this.hasCapitalCase &&
                           this.hasSmallCase &&
                           this.hasSpecialChar &&
                           this.passwordsMatch;
  }

  onInputFocus() {
    this.loginError = '';
  }

  togglePasswordVisibility(passwordInput: HTMLInputElement) {
    this.showPassword = !this.showPassword;
    passwordInput.type = this.showPassword ? 'text' : 'password';
  }

  toggleConfirmPasswordVisibility(confirmPasswordInput: HTMLInputElement) {
    this.showConfirmPassword = !this.showConfirmPassword;
    confirmPasswordInput.type = this.showConfirmPassword ? 'text' : 'password';
  }

  addHoverClass() {
    this.hoverClassAdded = true;
  }

  addHoverClass2() {
    this.hoverClassAdded2 = true;
  }

  removeHoverClass() {
    this.hoverClassAdded = false;
  }

  removeHoverClass2() {
    this.hoverClassAdded2 = false;
  }

    // Función para validar los criterios de contraseña
    validatePassword(password: string) {
      //console.log(this.isLengthValid);
      this.isLengthValid = password.length >= 8;
      this.hasNumber = /[0-9]/.test(password);
      this.hasCapitalCase = /[A-Z]/.test(password);
      this.hasSmallCase = /[a-z]/.test(password);
      this.hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(password);
  }

  returnToLogin() {
    localStorage.clear();
    this.router.navigate(['/login']);
  }
}
